import type {RouteLocationNormalized} from 'vue-router';

import {useUserStore} from '@/shared/stores/user.store';

function checkAuth(auth: boolean, authRequired: boolean, redirectPath: string) {
   return auth === authRequired ? true : redirectPath;
}

// Function to check access to protected pages
export function requireLogin(
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   to: RouteLocationNormalized,
) {
   const {isDashboardAuth} = useUserStore();
   return checkAuth(isDashboardAuth(), true, '/login'); // Redirects to /login if not logged in
}

export function requireStudentLogin(
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   to: RouteLocationNormalized,
) {
   const {isStudentAuth} = useUserStore();
   return checkAuth(isStudentAuth(), true, '/student-login'); // Redirects to /student-login if not logged in
}

// Function to check access to guest pages (e.g. login page)
export function guest(
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   to: RouteLocationNormalized,
) {
   const {isAuth} = useUserStore();
   return checkAuth(isAuth, false, '/'); // Redirects to / if logged in
}
